import React, { useEffect, useState, useMemo } from "react";
import { ThemeProvider, createTheme, CssBaseline } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { sessionActions } from "./store/session";

// Função para capturar host dinâmico
const getCurrentDomain = () => {
  if (typeof window !== "undefined") {
    return window.location.origin;
  }
  return "http://localhost:3000";
};

const RevendaProvider = ({ children }) => {
  const dispatch = useDispatch();
  const revenda = useSelector((state) => state.session.revenda);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRevenda = async () => {
      try {
        const domain = getCurrentDomain();
        const url = `/api/revendas/public?domain=${encodeURIComponent(domain)}`;

        const res = await fetch(url);
        if (!res.ok) throw new Error(`Erro ao carregar revenda (${res.status})`);

        const data = await res.json();
        if (Array.isArray(data) && data.length > 0) {
          // ✅ Corrigido: usar sessionActions.setRevenda
          dispatch(sessionActions.setRevenda(data[0]));
        } else {
          console.warn("Nenhuma revenda encontrada para o domínio:", domain);
        }
      } catch (err) {
        console.error("Erro ao buscar revenda:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchRevenda();
  }, [dispatch]);

  // Criar tema dinâmico baseado nas cores da revenda
  const theme = useMemo(() => {
    const primaryColor = revenda?.color1 || "#1976d2"; // azul padrão
    const secondaryColor = revenda?.color2 || "#f50057"; // rosa padrão

    return createTheme({
      palette: {
        mode: "light", // poderia ser dinâmico (dark/light)
        primary: { main: primaryColor },
        secondary: { main: secondaryColor },
        background: {
          default: "#0a192f", // fallback fundo
          paper: "#1c2536",   // fallback card
        },
      },
      shape: { borderRadius: 8 },
      typography: {
        fontFamily: "'Roboto', sans-serif",
      },
    });
  }, [revenda]);

  if (loading) {
    return null; // ou um spinner se quiser
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};

export default RevendaProvider;
